export default __webpack_public_path__ + "static/media/logo-tag.3871a161.png";